import Module from '../../utils/modules/Module';

export default class TabTilesModule extends Module {
  constructor(options) {
    super(options)
    this.DOMEl = this.options.element;

    this.itemsRadio = this.DOMEl.querySelectorAll('.radiotab');

    this.fixClose();
  }

  fixClose(){
    this.itemsRadio.forEach((item) => {
      item.addEventListener('click', function (el) {
        if (el.currentTarget.classList.contains('active')) {
          el.currentTarget.checked = false;
          el.currentTarget.classList.remove('active');
        }
        else {
          el.currentTarget.closest('.tabs').querySelectorAll('.radiotab.active').forEach((activeItems) => {
            activeItems.classList.remove('active');
          })
          el.currentTarget.classList.add('active');
          el.currentTarget.nextElementSibling.nextElementSibling.scrollIntoView('alignToTop');
        }
      })
    });

  }
}
